import { render, staticRenderFns } from "./ImageContentBlock.vue?vue&type=template&id=4825f6d7&"
import script from "./ImageContentBlock.vue?vue&type=script&lang=js&"
export * from "./ImageContentBlock.vue?vue&type=script&lang=js&"
import style0 from "./ImageContentBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports